/* Полоса визуала — орган ЭКРАНА, а не превью, и стоит она снаружи `.tgzone`. Отсюда
   обязательность фирменных токенов: именно они делают видимой границу «здесь кончается
   чужой клиент». Ни одного цвета литералом (правило docs/frontend.md).

   Геометрия совпадает с `.lps` из base.css один в один намеренно: плашка карточки превью и
   полоса визуала отвечают на ОДИН вопрос — «что будет под текстом», — и разная посадка
   читалась бы как разная природа. */

.strip {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--r-card);
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 9px;
  min-width: 0;
}

/* Пока гейт открыт, полоса — единственное место на экране, где решение можно принять.
   Левая линейка и подложка держат её видимой на длинном посте, где полоса решений внизу
   уже сообщила «Блокирует утверждение», а причина осталась выше границы окна. */
.stripGate {
  border-left: 2px solid var(--violet);
  background: var(--violet-bg);
}

.head {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
}

.body {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  flex-wrap: wrap;
}

.thumbWrap {
  flex: 0 0 auto;
  min-width: 0;
}

/* `aspect-ratio` ставится инлайном из размеров предложения: место под картинку резервируется
   до прихода байтов, иначе полоса подпрыгивает на каждой перерисовке. */
.thumb {
  max-width: 320px;
  width: 100%;
  display: block;
  border-radius: var(--r-ctl);
  border: 1px solid var(--border);
  background: var(--bg-alt);
  object-fit: contain;
}

.text {
  flex: 1 1 260px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

/* Баннер зоны сброса. Появляется только на перетаскивании — постоянная пунктирная рамка
   на экране согласования читалась бы как незаполненное поле формы. */
.dropHint {
  border: 2px dashed var(--violet);
  background: var(--violet-bg);
  border-radius: var(--r-ctl);
  padding: 10px 12px;
  color: var(--accent-ink);
  font-size: 12.5px;
  font-weight: 600;
  text-align: center;
}
